export const colors = {
    RED: "#e31206",
    GREEN: "#64aa5c",
    SKIN: "#b8b8b8"
}